import { Component, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocationGroup, LocationGroupDialogData } from '@core/interfaces';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';

import english from './../../../i18n/en.json';
import spanish from './../../../i18n/es.json';
import portuguese from './../../../i18n/pt.json';

@Component({
  selector: 'tab-locations-groups',
  templateUrl: './tab-locations-groups.component.html'
})
export class TabLocationsGroupsComponent implements OnInit {
  @Output() getLocationGroupForm: Subject<FormGroup> = new Subject();
  public locationGroupForm: FormGroup;
  public locationGroup: LocationGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LocationGroupDialogData,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private formBuilder: FormBuilder
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.locationGroup = this.data.locationGroup;

    this.locationGroupForm = this.formBuilder.group({
      name: [this.locationGroup.name, [Validators.required, Validators.maxLength(100)]],
      description: this.locationGroup.description
    });

    if (this.data.isViewMode) {
      this.locationGroupForm.disable();
    }
  }

  ngOnInit(): void {
    this.locationGroupForm.valueChanges.subscribe(() => this.getLocationGroupForm.next(this.locationGroupForm));
    this.getLocationGroupForm.next(this.locationGroupForm);
  }
}
